export class DocumentTemplateRoleName {
  id: number;
  name: string;
  editing: boolean = false;
}
